/* =========================================================================
   HERMES — Suero Cuidado de Uñas · v1b · vanilla JS (no deps)
   CTA pattern: PASO 51.2 corregido — un solo botón real con hook classes
   (#hm-una-main-cta), hero/sticky son anchors <a href="#hm-una-cta-final">
   que solo hacen scroll nativo. Releasit exige click isTrusted:true sobre
   SU propio elemento — nunca se dispara via proxy/dispatchEvent.
   ========================================================================= */
(function () {
  'use strict';
  var ROOT = document.querySelector('.hm-una');
  if (!ROOT) return;

  /* -----------------------------------------------------------------------
     0) ANTI-SPY + DESKTOP BLOCK
     ----------------------------------------------------------------------- */
  var caught = document.getElementById('hm-una-caught');
  var antiSpyOn = ROOT.classList.contains('hm-una--anti-spy');
  var desktopBlockOn = ROOT.classList.contains('hm-una--desktop-block');

  function showCaught(mode) {
    if (!caught) return;
    caught.classList.add('is-active');
    caught.setAttribute('data-hm-una-mode-active', mode);
    caught.querySelectorAll('.hm-una-caught__mode').forEach(function (m) {
      m.classList.toggle('is-shown', m.getAttribute('data-hm-una-mode') === mode);
    });
  }

  function isDesktopLike() {
    try {
      var wide = window.matchMedia('(min-width: 1024px)').matches;
      var hoverFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var noTouch = !('ontouchstart' in window) && navigator.maxTouchPoints === 0;
      return wide || hoverFine || noTouch;
    } catch (e) { return false; }
  }

  if (desktopBlockOn && isDesktopLike()) {
    showCaught('desktop');
  }

  if (antiSpyOn) {
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault();
      if (!isDesktopLike()) showCaught('spy');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].indexOf(e.key.toUpperCase()) > -1)) {
        e.preventDefault();
        showCaught('spy');
      }
    });
    var devtoolsThreshold = 200;
    setInterval(function () {
      var wDelta = window.outerWidth - window.innerWidth;
      var hDelta = window.outerHeight - window.innerHeight;
      if ((wDelta > devtoolsThreshold || hDelta > devtoolsThreshold) && !isDesktopLike()) {
        showCaught('spy');
      }
    }, 1200);
  }

  /* If blocked, short-circuit the rest (no animations, no Releasit setup) */
  if (desktopBlockOn && isDesktopLike()) return;

  /* -----------------------------------------------------------------------
     1) PRELOADER — 0 → 100 + rotating words
     ----------------------------------------------------------------------- */
  (function preloader() {
    var pre = document.getElementById('hm-una-preloader');
    var counter = document.getElementById('hm-una-counter');
    var bar = document.getElementById('hm-una-bar');
    var words = document.querySelectorAll('.hm-una-pw');
    if (!pre) return;
    var n = 0;
    var wIdx = 0;
    var interval = setInterval(function () {
      n += Math.ceil(Math.random() * 9) + 3;
      if (n >= 100) n = 100;
      if (counter) counter.textContent = n;
      if (bar) bar.style.width = n + '%';
      if (n >= 100) {
        clearInterval(interval);
        setTimeout(function () {
          pre.classList.add('is-done');
          document.dispatchEvent(new CustomEvent('hmuna:preloaderDone'));
        }, 260);
      }
    }, 110);
    if (words.length) {
      setInterval(function () {
        words[wIdx].classList.remove('active');
        wIdx = (wIdx + 1) % words.length;
        words[wIdx].classList.add('active');
      }, 650);
    }
  })();

  /* -----------------------------------------------------------------------
     2) Brush-stroke reveal — hero headline (clip-path wipe, custom para esta categoría)
     ----------------------------------------------------------------------- */
  setTimeout(function () {
    document.querySelectorAll('[data-brush]').forEach(function (el) {
      var delay = parseFloat(el.getAttribute('data-brush-delay') || '0');
      setTimeout(function () { el.classList.add('is-in'); }, 350 + delay * 1000);
    });
  }, 0);

  /* -----------------------------------------------------------------------
     3) IntersectionObserver generic reveal (stats, dotbox)
     ----------------------------------------------------------------------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.hm-una-stat, .hm-una-dotbox').forEach(function (el) { io.observe(el); });

  /* -----------------------------------------------------------------------
     4) Rotating words — full-bleed cycling (role-fade)
     ----------------------------------------------------------------------- */
  (function rotator() {
    var words = document.querySelectorAll('.hm-una-rotator__word');
    if (!words.length) return;
    var idx = 0;
    setInterval(function () {
      words[idx].classList.remove('active');
      idx = (idx + 1) % words.length;
      words[idx].classList.add('active');
    }, 2000);
  })();

  /* -----------------------------------------------------------------------
     5) Sticky CTA — dual IntersectionObserver (hero out / final in)
     ----------------------------------------------------------------------- */
  (function stickyCta() {
    var sticky = document.querySelector('[data-hm-una-sticky]');
    var heroCta = document.querySelector('.hm-una-hero__cta');
    var finalCta = document.getElementById('hm-una-cta-final');
    if (!sticky) return;
    var heroVisible = true;
    var finalVisible = false;

    function sync() {
      sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);
    }
    if (heroCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { heroVisible = e.isIntersecting; sync(); });
      }, { threshold: 0 }).observe(heroCta);
    }
    if (finalCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { finalVisible = e.isIntersecting; sync(); });
      }, { rootMargin: '0px 0px -40% 0px' }).observe(finalCta);
    }
  })();

  /* -----------------------------------------------------------------------
     6) CTA — regla PASO 51.2: el hero y el sticky son anchors nativos
     <a href="#hm-una-cta-final"> (sin JS), aterrizan justo sobre el botón
     final real (#hm-una-main-cta) que lleva las hook classes Releasit
     directamente. Releasit lo reemplaza in-place con su propio botón y
     exige un click isTrusted:true — NUNCA se dispara por proxy/dispatchEvent.
     No hay listener dedicado aquí; el navegador resuelve el scroll solo.
     ----------------------------------------------------------------------- */

  /* -----------------------------------------------------------------------
     7) Kill Releasit floating button dinámicamente (por si CSS no atrapa clase nueva)
     ----------------------------------------------------------------------- */
  (function killFloating() {
    var tries = 0;
    var maxTries = 48; /* 24s @ 500ms */
    var iv = setInterval(function () {
      tries++;
      document.querySelectorAll('._rsi-buy-now-button-floating, [class*="_rsi-buy-now"][class*="floating"], [class*="_rsi-floating"]').forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      });
      if (tries >= maxTries) clearInterval(iv);
    }, 500);
  })();

  /* -----------------------------------------------------------------------
     8) Releasit submit skin — vence inline styles !important del merchant
     ----------------------------------------------------------------------- */
  (function releasitSubmitSkin() {
    function skin(el) {
      if (!el) return;
      el.style.setProperty('background', 'linear-gradient(135deg, #E0768A, #E2C08F)', 'important');
      el.style.setProperty('color', '#000000', 'important');
      el.style.setProperty('border-radius', '999px', 'important');
      el.style.setProperty('border', 'none', 'important');
      el.style.setProperty('font-weight', '700', 'important');
      el.style.setProperty('min-height', '54px', 'important');
      el.style.setProperty('width', '100%', 'important');
    }
    function sweep() {
      document.querySelectorAll('[class*="_rsi"][class*="submit"], [class*="_rsi-cod-form"] button[type="submit"], [class*="_rsi-modal"] button').forEach(skin);
    }
    sweep();
    var mo = new MutationObserver(sweep);
    mo.observe(document.body, { childList: true, subtree: true });
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      sweep();
      if (tries >= 80) clearInterval(iv); /* ~40s @ 500ms */
    }, 500);
    document.addEventListener('click', function () { setTimeout(sweep, 60); });
  })();

  console.info('[HERMES una] chassis ready');
})();
